module.exports = __webpack_public_path__ + "media/country_flags/so-128bad03.png";